<div
  id="user"
  class="page-layout blank p-24"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    @if (selectedUser.avsAlign !== false) {
      <div
        class="name"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ selectedUser.firstName }} {{ selectedUser.lastName }}
      </div>
    } @else {
      <div
        class="name"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ selectedUser.misalignedFirstname }} {{ selectedUser.misalignedName }}
      </div>
    }
  </div>
  <!-- / HEADER -->
  <div class="content" fxLayout="row wrap">
    <!-- CONTENT CARD -->
    <div class="content-card" fxFill>
      @if (isLoading || isLoadingName) {
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
          class="mat-progress-bar"></mat-progress-bar>
      }
      <!-- CONTENT -->
      @if (!isLoading) {
        <div class="content">
          <mat-tab-group
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            fxLayout="column"
            fxFlex
            fxFill
            [selectedIndex]="selectedIndex"
            (selectedTabChange)="tabChanged($event)">
            <mat-tab label="{{ 'USERS.SINGLE.TABS1.TITLE' | translate }} ">
              @if (mustChangemail) {
                <div class="message-box warning">
                  {{ 'SECURITY.CHANGEEMAIL' | translate }}
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    class="btn-container"
                    (click)="changeEmailLink()">
                    {{ 'SECURITY.CHANGEEMAILBTN' | translate }}
                  </button>
                </div>
              }
              @if (errorAccess) {
                <div class="message-box error">
                  {{ 'ERROR.19' | translate }}
                </div>
              }
              <div class="content" fxLayout="row wrap">
                <div
                  fxLayout="column"
                  fxFlex="30"
                  fxFlex.md="30"
                  fxFlex.sm="50"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="mat-card profile-card">
                    <h2 class="card-title">
                      {{ 'USERS.SINGLE.TABS1.MYBASICINFO' | translate }}
                    </h2>
                    @if (checkPermission() && !isUploadImageDisabled) {
                      <div
                        class="profile-picture"
                        id="clickable"
                        fxLayoutAlign="center center">
                        <img
                          class="profile-image"
                          [src]="
                            selectedFileUrl
                              ? selectedFileUrl
                              : 'assets/images/avatars/avatar.png'
                          "
                          [@animate]="{
                            value: '*',
                            params: { delay: '50ms', scale: '1' },
                          }"
                          alt="Avatar du profil" />
                        @if (
                          this.selectedFileUrl !== null && checkPermission()
                        ) {
                          <div class="icons">
                            @if (this.selectedFileUrl !== null) {
                              <button
                                class="icon-button"
                                (click)="openDialog()">
                                <mat-icon class="custom-icon">edit</mat-icon>
                              </button>
                            }
                            @if (this.selectedFileUrl !== null) {
                              <button
                                class="icon-button"
                                style="color: #f44336"
                                (click)="openDialogDelete()">
                                <mat-icon class="custom-icon">delete</mat-icon>
                              </button>
                            }
                            @if (
                              this.selectedFileUrl === null && checkPermission()
                            ) {
                              <mat-icon class="custom-icon"
                                >add_circle_outline</mat-icon
                              >
                            }
                          </div>
                        }
                        @if (
                          this.selectedFileUrl === null && checkPermission()
                        ) {
                          <div class="icons">
                            @if (this.selectedFileUrl === null) {
                              <button
                                class="icon-button"
                                (click)="openDialog()">
                                @if (
                                  this.selectedFileUrl === null &&
                                  checkPermission()
                                ) {
                                  <mat-icon class="custom-icon"
                                    >add_circle_outline</mat-icon
                                  >
                                }
                              </button>
                            }
                          </div>
                        }
                      </div>
                    } @else {
                      <div
                        class="profile-picture"
                        fxLayoutAlign="center center">
                        <img
                          class="profile-image"
                          [src]="
                            selectedFileUrl
                              ? selectedFileUrl
                              : 'assets/images/avatars/avatar.png'
                          "
                          [@animate]="{
                            value: '*',
                            params: { delay: '50ms', scale: '1' },
                          }"
                          alt="Avatar du profil" />
                      </div>
                    }
                    @if (checkPermission() && isUploadImageDisabled) {
                      <div class="message-box warning">
                        {{
                          'USERS.SINGLE.TABS3.MAINTENANCE-PICTURE' | translate
                        }}
                      </div>
                    }
                    @if (selectedUser.avsAlign !== false) {
                      <div fxLayoutAlign="center center" class="profile-name">
                        {{ selectedUser.firstName }} {{ selectedUser.lastName }}
                      </div>
                    } @else {
                      <div fxLayoutAlign="center center" class="profile-name">
                        {{ selectedUser.misalignedFirstname }}
                        {{ selectedUser.misalignedName }}
                      </div>
                    }
                    <mat-list role="list">
                      <mat-list-item>
                        <mat-icon matListItemIcon>cake</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ selectedUser.dateOfBirth }}
                        </h4>
                      </mat-list-item>
                      @if (selectedUser.avsAlign !== false) {
                        <mat-list-item>
                          <mat-icon matListItemIcon>person</mat-icon>
                          <h4 matListItemTitle class="nobreak">
                            {{ usergender }}
                          </h4>
                        </mat-list-item>
                      }
                      <mat-list-item>
                        <mat-icon matListItemIcon>language</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ userlangage }}
                        </h4>
                      </mat-list-item>
                    </mat-list>
                  </mat-card>
                </div>
                <div
                  ffxLayout="column"
                  fxFlex="70"
                  fxFlex.md="70"
                  fxFlex.sm="50"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="mat-card profile-card">
                    <h2>{{ 'USERS.SINGLE.TABS1.ADVANCEDINFO' | translate }}</h2>
                    <form fxLayout="column" [formGroup]="profilform">
                      <div fxFlex="2 0 auto" fxLayout="row">
                        <mat-form-field fxFlex="100" appearance="outline">
                          <mat-label>{{
                            'USERS.SINGLE.INFO.ADDRESS' | translate
                          }}</mat-label>
                          <input
                            autoComplete="on"
                            matInput
                            formControlName="address" />
                        </mat-form-field>
                      </div>
                      <div fxFlex="2 0 auto" fxLayout="row">
                        <mat-form-field fxFlex="100" appearance="outline">
                          <mat-label>{{
                            'USERS.SINGLE.INFO.NPA' | translate
                          }}</mat-label>
                          <input
                            autoComplete="on"
                            matInput
                            formControlName="zip" />
                        </mat-form-field>
                      </div>
                      <div fxFlex="2 0 auto" fxLayout="row">
                        <mat-form-field fxFlex="100" appearance="outline">
                          <mat-label>{{
                            'USERS.SINGLE.INFO.LOCALITY' | translate
                          }}</mat-label>
                          <input
                            autoComplete="on"
                            matInput
                            formControlName="locality" />
                        </mat-form-field>
                      </div>
                      @if (isBusy) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <mat-progress-spinner
                            [color]="spinner.color"
                            [mode]="spinner.mode"
                            [value]="spinner.value"
                            [diameter]="spinner.diameter">
                          </mat-progress-spinner>
                        </div>
                      }
                      @if (errorUpdate) {
                        <div class="general-container">
                          <div class="message-box error">
                            <app-error-message [error]="error.error" />
                          </div>
                        </div>
                      }
                      @if (isUserUpdated) {
                        <div class="general-container">
                          <div class="message-box success">
                            {{ 'PROFILE.FORM.SUCCESS' | translate }}
                          </div>
                        </div>
                      }
                    </form>
                  </mat-card>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="{{ 'GENERAL.TITLE.SECURITY' | translate }} ">
              <div class="content" fxLayout="row wrap">
                <div
                  fxLayout="column"
                  fxFlex="50"
                  fxFlex.md="50"
                  fxFlex.sm="100"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="security-card">
                    <h2>{{ 'USERS.SINGLE.TABS3.MYSUBTITLE' | translate }}</h2>
                    <div class="message-box warning">
                      {{ 'USERS.SINGLE.TABS3.MYDESCRIPTION' | translate }}
                    </div>
                    <br />
                    <span>
                      {{ 'USERS.SINGLE.TABS3.PWDCRITERIA' | translate }}
                    </span>
                    <mat-list role="list">
                      <mat-list-item>
                        <mat-icon matListItemIcon>vpn_key</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ 'ERROR.INTERDICTION' | translate }}
                        </h4>
                      </mat-list-item>
                      <mat-list-item>
                        <mat-icon matListItemIcon>vpn_key</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ 'ERROR.COMPLEXITY' | translate }}
                        </h4>
                      </mat-list-item>
                      <mat-list-item>
                        <mat-icon matListItemIcon>vpn_key</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ 'ERROR.CONTAINNAME' | translate }}
                        </h4>
                      </mat-list-item>
                      <mat-list-item>
                        <mat-icon matListItemIcon>vpn_key</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ 'ERROR.MIN' | translate }}
                        </h4>
                      </mat-list-item>
                      <mat-list-item>
                        <mat-icon matListItemIcon>vpn_key</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ 'ERROR.MAX' | translate }}
                        </h4>
                      </mat-list-item>
                      <mat-list-item>
                        <mat-icon matListItemIcon>vpn_key</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ 'ERROR.HISTORY' | translate }}
                        </h4>
                      </mat-list-item>
                    </mat-list>
                  </mat-card>
                </div>
                <div
                  fxLayout="column"
                  fxFlex="50"
                  fxFlex.md="50"
                  fxFlex.sm="100"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="security-card">
                    <h2>{{ 'SECURITY.FORM.TITLE' | translate }}</h2>
                    @if (
                      lastPasswordModification$ | async;
                      as lastModificationDate
                    ) {
                      @if (lastModificationDate) {
                        <div class="message-box warning">
                          {{ 'USER.LAST-UPDATE' | translate }}
                          {{ lastModificationDate | date: 'dd.MM.yyyy, hh:mm' }}
                        </div>
                      }
                    }
                    <form fxLayout="column" [formGroup]="securityform">
                      <div fxFlex="1 0 auto" fxLayout="column">
                        <div fxFlex="2 0 auto" fxLayout="column">
                          <mat-form-field
                            appearance="outline"
                            class="field-container">
                            <mat-label>{{
                              'SECURITY.OLDPASSWORD.TITLE' | translate
                            }}</mat-label>
                            <app-pass-visibility
                              #toggleOld
                              matSuffix></app-pass-visibility>
                            <input
                              autoComplete="on"
                              matInput
                              formControlName="oldpassword"
                              required
                              [type]="toggleOld.type"
                              placeholder="Old Password"
                              [formControl]="
                                securityform.get('oldpassword') | formPipe
                              " />
                            @if (securityform.get('oldpassword').invalid) {
                              <mat-error class="error-password">
                                {{ getErrorMessageOldPassword() }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div fxFlex="2 0 auto" fxLayout="column">
                          <mat-form-field
                            appearance="outline"
                            class="field-container">
                            <mat-label>{{
                              'SECURITY.PASSWORD.TITLE' | translate
                            }}</mat-label>
                            <app-pass-visibility
                              #toggleNew
                              matSuffix></app-pass-visibility>
                            <input
                              autoComplete="on"
                              matInput
                              formControlName="password"
                              required
                              [type]="toggleNew.type"
                              placeholder="Password"
                              [formControl]="
                                securityform.get('password') | formPipe
                              " />
                            @if (securityform.get('password').invalid) {
                              <mat-error class="error-password">
                                {{ getErrorMessage() }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div fxFlex="2 0 auto" fxLayout="column">
                          <mat-form-field
                            appearance="outline"
                            class="field-container">
                            <mat-label>{{
                              'SECURITY.PASSWORDCONFIRMATION.TITLE' | translate
                            }}</mat-label>
                            <app-pass-visibility
                              #toggleConfirm
                              matSuffix></app-pass-visibility>
                            <input
                              autoComplete="on"
                              matInput
                              formControlName="passwordConfirmation"
                              required
                              [type]="toggleConfirm.type"
                              placeholder=""
                              [formControl]="
                                securityform.get('passwordConfirmation')
                                  | formPipe
                              " />
                          </mat-form-field>
                        </div>
                        @if (securityform.hasError('passwordNotMatch')) {
                          <mat-error class="message-box error">
                            {{ 'ERROR.IDENTICALPSWD' | translate }}
                          </mat-error>
                        }
                      </div>
                      <div
                        class="general-container"
                        fxLayout="row"
                        fxLayoutAlign="left center">
                        <button
                          mat-raised-button
                          matStepperNext
                          type="button"
                          color="accent"
                          (click)="changePwd()"
                          [disabled]="
                            securityform.invalid ||
                            isBusy ||
                            isPasswordChangeDisabled
                          ">
                          {{ 'GENERAL.SAVE' | translate }}
                        </button>
                      </div>
                      @if (isPasswordChangeDisabled) {
                        <div class="message-box warning">
                          {{ 'USERS.SINGLE.TABS3.MAINTENANCE' | translate }}
                        </div>
                      }
                      @if (isBusyUpdatePwd) {
                        <div
                          class="general-container"
                          fxLayout="column"
                          fxLayoutAlign="center center">
                          <mat-progress-spinner
                            [color]="spinner.color"
                            [mode]="spinner.mode"
                            [value]="spinner.value"
                            [diameter]="spinner.diameter">
                          </mat-progress-spinner>
                          <div class="loading-container">
                            {{ 'GENERAL.LOADING' | translate }}
                          </div>
                        </div>
                      }
                      @if (isErrorUpdatePwd) {
                        <div class="general-container">
                          <div class="message-box error">
                            <app-error-message [error]="errorUpdatePwd.error" />
                          </div>
                        </div>
                      }
                      @if (isPwdUpdated) {
                        <div class="general-container">
                          <div class="message-box success">
                            {{ 'SECURITY.FORM.SUCCESS' | translate }}
                          </div>
                        </div>
                      }
                    </form>
                  </mat-card>
                </div>
              </div>
              <div class="content" fxLayout="row wrap">
                <div
                  fxLayout="column"
                  fxFlex="50"
                  fxFlex.md="50"
                  fxFlex.sm="100"
                  fxFlex.xs="100"
                  fxLayout="column">
                  @if (!isStudent) {
                    <mat-card class="security-card">
                      <h2>
                        {{ 'USERS.SINGLE.TABS3.SUBTITLEOTP' | translate }}
                      </h2>
                      <br />
                      <span> {{ 'OTP.DESC.DESCRIPTION' | translate }} </span>
                      <mat-list role="list">
                        <mat-list-item>
                          <mat-icon matListItemIcon>check_circle</mat-icon>
                          <h4 matListItemTitle class="nobreak">
                            {{ 'OTP.DESC.CHECK1' | translate }}
                          </h4>
                        </mat-list-item>
                        <mat-list-item>
                          <mat-icon matListItemIcon>check_circle</mat-icon>
                          <h4 matListItemTitle class="nobreak">
                            {{ 'OTP.FORM.CHECK2' | translate }}
                          </h4>
                        </mat-list-item>
                      </mat-list>
                    </mat-card>
                  }
                  @if (isStudent) {
                    <mat-card class="security-card">
                      <h2>
                        {{ 'USERS.SINGLE.TABS3.SUBTITLEOTP' | translate }}
                      </h2>
                      <br />
                      <span>
                        {{ 'OTP.DESC-STU.DESCRIPTION' | translate }}
                      </span>
                      <mat-list role="list">
                        <mat-list-item>
                          <mat-icon matListItemIcon>check_circle</mat-icon>
                          <h4 matListItemTitle class="nobreak">
                            {{ 'OTP.DESC-STU.CHECK1' | translate }}
                          </h4>
                        </mat-list-item>
                        <mat-list-item>
                          <mat-icon matListItemIcon>check_circle</mat-icon>
                          <h4 matListItemTitle class="nobreak">
                            {{ 'OTP.FORM.CHECK2' | translate }}
                          </h4>
                        </mat-list-item>
                      </mat-list>
                    </mat-card>
                  }
                </div>
                <div
                  fxLayout="column"
                  fxFlex="50"
                  fxFlex.md="50"
                  fxFlex.sm="100"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="security-card">
                    <h2>{{ 'OTP.FORM.TITLE' | translate }}</h2>
                    <form fxLayout="column" [formGroup]="optform">
                      <div fxFlex="1 0 auto" fxLayout="column">
                        <div fxFlex="2 0 auto" fxLayout="column">
                          <mat-form-field
                            appearance="outline"
                            class="field-container">
                            <mat-label>{{
                              'SECURITY.OLDPASSWORD.TITLE' | translate
                            }}</mat-label>
                            <app-pass-visibility
                              #toggleOtp
                              matSuffix></app-pass-visibility>
                            <input
                              autoComplete="on"
                              matInput
                              formControlName="password_otp"
                              required
                              [type]="toggleOtp.type"
                              placeholder=""
                              [formControl]="
                                optform.get('password_otp') | formPipe
                              " />
                            @if (optform.get('password_otp').invalid) {
                              <mat-error class="error-password">
                                {{ getErrorMessageOTP() }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div fxFlex="2 0 auto" fxLayout="row">
                          <mat-form-field fxFlex="100" appearance="outline">
                            <mat-label>{{
                              'USERS.SINGLE.INFO.RECOVERYEMAIL' | translate
                            }}</mat-label>
                            <input
                              autoComplete="on"
                              matInput
                              required
                              formControlName="email" />
                            @if (optform.get('email').invalid) {
                              <mat-error class="error-password">{{
                                getEmailErrorMessage()
                              }}</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div fxFlex="2 0 auto" fxLayout="row">
                          <mat-form-field fxFlex="20" appearance="outline">
                            <mat-select
                              placeholder="IND"
                              formControlName="defaultDial"
                              required>
                              <mat-option [value]="'+41'"> +41 </mat-option>
                              <mat-option [value]="'+33'"> +33 </mat-option>
                              <mat-option [value]="'+49'"> +49 </mat-option>
                              <mat-option [value]="'+39'"> +39 </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field
                            fxFlex="80"
                            appearance="outline"
                            [hideRequiredMarker]="hiderequired">
                            <mat-label>{{
                              'USERS.SINGLE.INFO.PHONE' | translate
                            }}</mat-label>
                            <input
                              autoComplete="on"
                              matInput
                              formControlName="phone"
                              [maxLength]="maxlength"
                              placeholder="791234567" />
                          </mat-form-field>
                        </div>
                        <div
                          class="general-container"
                          fxLayout="row"
                          fxLayoutAlign="left center">
                          <button
                            mat-raised-button
                            matStepperNext
                            type="button"
                            color="accent"
                            (click)="updateUserOTP()"
                            [disabled]="
                              optform.invalid ||
                              isBusyUpdateOtp ||
                              isPasswordChangeDisabled
                            ">
                            {{ 'OTP.FORM.TITLE' | translate }}
                          </button>
                        </div>
                      </div>
                      @if (isBusyUpdateOtp) {
                        <div
                          class="general-container"
                          fxLayout="row"
                          fxLayoutAlign="center center">
                          <mat-progress-spinner
                            [color]="spinner.color"
                            [mode]="spinner.mode"
                            [value]="spinner.value"
                            [diameter]="spinner.diameter">
                          </mat-progress-spinner>
                        </div>
                      }
                      @if (isErrorUpdateOtp) {
                        <div class="general-container">
                          <div class="message-box error">
                            <app-error-message [error]="errorUpdateOtp.error" />
                          </div>
                        </div>
                      }
                      @if (isOtpUpdated) {
                        <div class="general-container">
                          <div class="message-box success">
                            {{ 'OTP.FORM.SUCCESS' | translate }}
                          </div>
                        </div>
                      }
                    </form>
                  </mat-card>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
  </div>
</div>
